import React from 'react'
import PropTypes from 'prop-types'

import { Flex, Image } from '@chatterbug/aaron'

import mediaComplete from './assets/media-complete.svg'
import mediaIncomplete from './assets/media-incomplete.svg'
import vocabComplete from './assets/vocab-complete.svg'
import vocabIncomplete from './assets/vocab-incomplete.svg'
import writingComplete from './assets/writing-complete.svg'
import writingIncomplete from './assets/writing-incomplete.svg'
import conceptsComplete from './assets/concepts-complete.svg'
import conceptsIncomplete from './assets/concepts-incomplete.svg'

const ProgressIcons = ({ vocab, writing, media, concepts }) => {
  return (
    // ML is to align with the text start on mobile (adjusts for the icon offset)
    <Flex ml={{ _: '96px', tablet: 0 }} pt={{ _: '1x', tablet: 0 }}>
      {concepts.isPresent && (
        <Image
          src={concepts.isCompleted ? conceptsComplete : conceptsIncomplete}
          ml="-5px"
          alt=""
        />
      )}
      <Image
        src={vocab.isCompleted ? vocabComplete : vocabIncomplete}
        ml="-5px"
      />

      {writing.isPresent && (
        <Image
          src={writing.isCompleted ? writingComplete : writingIncomplete}
          ml="-5px"
        />
      )}
      {media.isPresent && (
        <Image
          src={media.isCompleted ? mediaComplete : mediaIncomplete}
          ml="-5px"
        />
      )}
    </Flex>
  )
}

ProgressIcons.propTypes = {
  vocab: PropTypes.shape({
    isCompleted: PropTypes.bool,
  }),
  writing: PropTypes.shape({
    isPresent: PropTypes.bool,
    isCompleted: PropTypes.bool,
  }),
  media: PropTypes.shape({
    isPresent: PropTypes.bool,
    isCompleted: PropTypes.bool,
  }),
  concepts: PropTypes.shape({
    isPresent: PropTypes.bool,
    isCompleted: PropTypes.bool,
  }),
}

export default ProgressIcons
